import { Q as QBusImpl } from './lib/c17a466e.mjs';
export { Q as QBusImpl, a as addModuleSubscription, b as addSubscription, p as publish, r as removeSubscription } from './lib/c17a466e.mjs';
import './lib/9f4ab352.mjs';

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function eventQBus() {
    return new QBusImpl();
}

export { eventQBus };
/*🤫*/
